import baseStyles from "../BaseInputs.module.css";

interface BaseCheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
  id: string;
  checked: boolean;
  change: (ret: boolean) => void;
  label?: string;
}

/**
 * Simple checkbox component used by the ObjectEditor for boolean fields.
 *
 * @param props - Destructured parameter object
 * @param props.id - Unique identifier used for the checkbox input and label.
 * @param props.checked - Current boolean checked state of the checkbox.
 * @param props.change - Callback invoked with the updated boolean state when toggled.
 * @param props.label - Optional label text displayed beside the checkbox.
 */
export const BaseCheckbox = ({
  id,
  checked,
  change,
  label,
  ...rest
}: BaseCheckboxProps): React.ReactElement => {
  /**
   * Toggle the checkbox state and notify change handlers.
   *
   * @param e - The event object
   */
  const handleClick = (e: React.MouseEvent<HTMLInputElement | HTMLLabelElement>) => {
    e.preventDefault();
    e.stopPropagation();
    change(!checked);
  };
  return (
    <div className={baseStyles.holder}>
      <input
        {...rest}
        type="checkbox"
        id={id}
        className={baseStyles.baseCheckbox}
        checked={checked}
        onChange={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={handleClick}
      />
      {label !== undefined && (
        <label
          id={`${id}-label`}
          htmlFor={id}
          className={baseStyles.baseCheckboxLabel}
          onClick={handleClick}
        >
          {label}
        </label>
      )}
    </div>
  );
};

BaseCheckbox.displayName = "BaseCheckbox";
